import type { NavSection } from '@/components/nav-main';

/**
 * The sidebar a given viewer should see.
 *
 * Items and whole sections can be marked `adminOnly`; a section also disappears
 * when everything inside it was admin-only, because a heading standing above
 * nothing reads as a broken page rather than a hidden one.
 *
 * This builds new arrays rather than filtering in place: the sidebar memoises
 * its nav array, so mutating it would permanently strip the links for a super
 * admin who switches organization.
 *
 * Hiding a link is only tidiness. The routes are guarded too — see
 * `RequireOwnerOrAdmin` — and the API is what actually protects the data.
 */
export function filterNavSections(sections: NavSection[], canSeeAdmin: boolean): NavSection[] {
  if (canSeeAdmin) return sections;

  return sections
    .filter((section) => !section.adminOnly)
    .map((section) => ({ ...section, items: section.items.filter((item) => !item.adminOnly) }))
    .filter((section) => section.items.length > 0);
}
